// extracted by mini-css-extract-plugin
module.exports = {"btn-icon":"icon-button_btn-icon__aJB9w","with-border":"icon-button_with-border__6D8d9","text-part":"icon-button_text-part__kFwux","icon-part":"icon-button_icon-part__bNkNa"};